import * as actionTypes from './actionTypes';

export const setGoogle = (google) => {
    return {
        type: actionTypes.SET_GOOGLE,
        google: google
    };
};

export const setMap = (map) => {
    return {
        type: actionTypes.SET_MAP,
        map: map
    };
};

export const toggleSearch = () => {
    return {
        type: actionTypes.SEARCH_TOGGLE
    };
};

export const onSearchChange = (place) => {
    return {
        type: actionTypes.ON_SEARCH_CHANGE,
        place: place
    };
};

export const onPlaceSelect = (place) => {
    return {
        type: actionTypes.ON_PLACE_SELECT,
        place: place
    };
};

export const initCenter = () => {
    return {
        type: actionTypes.INIT_SET_CENTER
    };
};

export const setCenter = (center) => {
    return {
        type: actionTypes.SET_CENTER,
        center: center
    };
};

export const zoomChanged = (newzoom) => {
    return {
        type: actionTypes.ZOOM_CHANGED,
        newzoom: newzoom
    };
};

export const radiusChanged = (newradius) => {
    return {
        type: actionTypes.RADIUS_CHANGED,
        newradius: newradius
    };
};